import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function AdvancedStopwatch() {
  const [time, setTime] = useState(0); // time in ms
  const [isRunning, setIsRunning] = useState(false);
  const [laps, setLaps] = useState([]);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        setTime((prev) => prev + 10);
      }, 10); // update every 10ms
    } else {
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [isRunning]);

  const formatTime = (ms) => {
    const milliseconds = String(ms % 1000).padStart(3, "0").slice(0, 2);
    const totalSeconds = Math.floor(ms / 1000);
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
    const seconds = String(totalSeconds % 60).padStart(2, "0");
    return `${hours}:${minutes}:${seconds}:${milliseconds}`;
  };

  const handleReset = () => {
    setIsRunning(false);
    setTime(0);
    setLaps([]);
  };

  const handleLap = () => {
    setLaps([...laps, time]);
  };

  return (
    <>
      <Helmet>
        <title>Online Stopwatch with Lap & Millisecond Timer - Free Tool</title>
        <meta
          name="description"
          content="Use a free, advanced online stopwatch with hours, minutes, seconds, milliseconds, and lap functionality. Accurate and easy to use timer for any purpose."
        />
        <meta
          name="keywords"
          content="online stopwatch, free stopwatch, stopwatch timer, lap timer, millisecond stopwatch, advanced timer, time tracker, stopwatch with lap feature, stopwatch with milliseconds"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/online-stopwatch-timer" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container text-center">
          <BackButton />
          <h2>Advanced Stopwatch</h2>

          <h1 className="display-4">{formatTime(time)}</h1>

          <div className="my-3">
            <button
              className="btn btn-success me-2"
              onClick={() => setIsRunning(true)}
              disabled={isRunning}
            >
              Start
            </button>
            <button
              className="btn btn-danger me-2"
              onClick={() => setIsRunning(false)}
              disabled={!isRunning}
            >
              Pause
            </button>
            <button className="btn btn-warning me-2" onClick={handleReset}>
              Reset
            </button>
            <button
              className="btn btn-info"
              onClick={handleLap}
              disabled={!isRunning}
            >
              Lap
            </button>
          </div>

          {laps.length > 0 && (
            <div className="mt-4">
              <h5>Laps:</h5>
              <ul className="list-group w-50 mx-auto">
                {laps.map((lap, index) => (
                  <li className="list-group-item" key={index}>
                    Lap {index + 1}: {formatTime(lap)}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
